import { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router';

import quickQuotLogo from '../../assets/images/laEstimator_powered.svg';
import { LANDING_SECTION_IDS } from '../../const';
import { routes } from '../../const/routes';
import './header.scss';

const Header = ({ selectedSection, setSelectedSection }) => {
  const navigationRef = useRef(null);
  const [isOpenMenu, setOpenMenu] = useState(false);
  const { pathname } = useLocation();

  // close menu on click outside the header
  useEffect(() => {
    const onClickOutside = (e) => {
      if (navigationRef.current && navigationRef.current === e.target) {
        isOpenMenu && setOpenMenu(false);
      }
    };

    window.addEventListener('click', onClickOutside);
    return () => {
      window.removeEventListener('click', onClickOutside);
    };
  });

  // close menu after route changing
  useEffect(() => {
    if (isOpenMenu) setOpenMenu(false);
    setSelectedSection('');
  }, [pathname]);

  const toggleNavigationMenu = () => {
    setOpenMenu(!isOpenMenu);
  };

  const handleLogoClick = () => {
    if (pathname === routes.landingPage) {
      window.scrollTo({
        top: 0,
      });
    }
  };

  return (
    <header>
      <div>
        <div className="logo-block">
          <img src={quickQuotLogo} alt="LaEstimator" width="226" height="28" />
          <Link
            to={routes.landingPage}
            title="Home"
            onClick={handleLogoClick}
          />
          <a
            href="https://lasoft.org/"
            title="Lasoft Innovation Lab"
            target="_blank"
            rel="noopener noreferrer"
          />
        </div>
        <nav className={`${isOpenMenu ? 'open' : ''}`} ref={navigationRef}>
          <ul>
            {LANDING_SECTION_IDS.map((link) => (
              <li key={link.id}>
                <a
                  href={`/#${link.id}`}
                  className={`menu-button ${selectedSection === link.id ? 'active' : ''}`}
                >
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        <div className="btn-block">
          <Link className="primaryFatLink ic-arrow-up" to={routes.formPage}>
            Calculate
          </Link>

          <button
            className={`hmb-btn ${isOpenMenu ? 'open' : ''}`}
            onClick={toggleNavigationMenu}
            aria-expanded={isOpenMenu ? 'true' : 'false'}
            aria-label={isOpenMenu ? 'Hide navigation' : 'Show navigation'}
            title={isOpenMenu ? 'Hide navigation' : 'Show navigation'}
            data-show={isOpenMenu}
          >
            <span /> <span /> <span /> <span />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
